module.exports = __webpack_public_path__ + "static/media/notice2_3.8df8966b.png";